// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1b7UQ","content":"Consent_content__3-YFU","footer":"Consent_footer__2D5m8"};